/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Feedback.css';
import cx from 'classnames';

class Feedback extends React.Component {

  // constructor() {   super();   this.state = { db: [] }; }

  constructor() {
    super();
    this.state = {
      db: []
    }
  }

  componentDidMount() {
    this.setState({
      db: [
        {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }, {
          name: '腾讯',
          industry: 'IT',
          db: '123',
          change: '+1',
          weixin: '123DB',
          weibo: '321DB',
          toutiao: 'fdjkas',
          zhihu: 'ZHIHU',
          mind: 'MIND'
        }
      ]
    });
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.dbRank}>
            <div className={s.dbTit}>
              <h3 className={s.h3Tit}>DBrank榜</h3>
              <span className={s.h3EnTit}>DIGITAL BRAND RANK</span>
              <span className={s.h3Int}>此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案文案此处放文案此处放文案</span>
            </div>
            <ul className={s.dbBtn}>
              <li>
                <a href="javascript:;" className={s.dayBtn}>日榜</a>
              </li>
              <li>
                <a href="javascript:;" className={s.dayBtn}>周榜</a>
              </li>
              <li>
                <a href="javascript:;" className={s.dayBtn}>月榜</a>
              </li>
            </ul>
            <ul className={s.dbKing}>
              <li>
                <a href="javascript:;" className={s.king2}/>
              </li>
              <li>
                <a href="javascript:;" className={s.king1}/>
              </li>
              <li>
                <a href="javascript:;" className={s.king3}/>
              </li>
            </ul>

            {/* <!--DBrank表格-->*/}
            <div className={s.dbTable}>
              <table
                style={{
                border: '0'
              }}
                cellSpacing={0}
                cellPadding={0}>
                {/* <table >*/}
                <tbody>
                  <tr>
                    <th>排名</th>
                    <th>品牌名称</th>
                    <th>行业</th>
                    <th>DB值</th>
                    <th>涨跌幅</th>
                    <th>微信DB值</th>
                    <th>微博DB值</th>
                    <th>头条DB值</th>
                    <th>知乎DB值</th>
                    <th>社交好感度指数</th>
                  </tr>
                  {this
                    .state
                    .db
                    .map(function (brand, index) {
                      return (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <td>{brand.name}</td>
                          <td>{brand.industry}</td>
                          <td>{brand.db}</td>
                          <td>{brand.change}</td>
                          <td>{brand.weixin}</td>
                          <td>{brand.weibo}</td>
                          <td>{brand.toutiao}</td>
                          <td>{brand.zhihu}</td>
                          <td>{brand.mind}</td>
                        </tr>
                      );
                    })
}

                </tbody>
              </table>
              <div>
                <a href="#" className={s.moreBtn}>查看榜单</a>
              </div>
            </div>
          </div>
        </div>

        {/* <!--DBrank表格结束-->*/}
        <div className={s.toDay}>

          <div className={s.toDayT}>
            <h3 className={cx(s.toDayTit, s.h3Tit)}>今日热点</h3>
            <span className={cx(s.toDayEn, s.h3EnTit)}>HEADLINE</span>
            <span className={cx(s.toDayInt, s.h3Int)}>此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案文案此处放文案此处放文案</span>
          </div>
          <div className={s.toDayB}>
            <h2 className={s.toDayH2}>2016中国品牌数字价值TOP100完整报告</h2>
          </div>

        </div>
        <div className={cx(s.service, s.container)}>
          <div className={s.dbTit}>

            <h3 className={s.h3Tit}>我们的服务</h3>
            <span className={s.h3EnTit}>OUR SERVICE</span>
            <span className={s.h3Int}>此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案此处放文案文案此处放文案此处放文案</span>
          </div>
          <ul className={s.serItem}>
            <li className={s.itemList}><i className={s.itemImg}/><span className={s.bar}/>
              <span className={s.itemName}>服务项目一</span>
              <span className={s.itemInt}>简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍 简单介绍简单介绍简单介绍简单 简单介绍简单介绍</span>
              <a href="#" className={cx(s.moreBtn, s.serBtn)}>申请试用</a>
            </li>
            <li className={s.itemList}><i className={s.itemImg}/><span className={s.bar}/>
              <span className={s.itemName}>服务项目一</span>
              <span className={s.itemInt}>简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍 简单介绍简单介绍简单介绍简单 简单介绍简单介绍</span>
              <a href="#" className={cx(s.moreBtn, s.serBtn)}>申请试用</a>
            </li>
            <li className={s.itemList}><i className={s.itemImg}/><span className={s.bar}/>
              <span className={s.itemName}>服务项目一</span>
              <span className={s.itemInt}>简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍简单介绍 简单介绍简单介绍简单介绍简单 简单介绍简单介绍</span>
              <a href="#" className={cx(s.moreBtn, s.serBtn)}>申请试用</a>
            </li>
          </ul>
        </div>

        <div className={cx(s.toDay, s.toDay2)}/>
        <div className={cx(s.about, s.container)}>
          <div className={s.dbTit}>

            <h3 className={s.h3Tit}>关于我们</h3>
            <span className={s.h3EnTit}>ABOUT US</span>
            <span className={s.h3Int}>一家极其珍视美好有趣的创意,致力科技+内容的初创企业</span>
            {/* <span className={s.aboutTxt}>我们是一家传播科技(Communication Technology)公司,为企业公关广告。市场 营销和运营提供基于社交</br>媒体大数据的传播决策服务，识别战场状况，提高心智占有率，计算品牌在数字时代的数字资产价值。</br> 数字品牌榜，社交媒体时代的用户口碑评价排行榜。</span>*/}

          </div>
          <span className={s.aboutTxt}>我们是一家传播科技(Communication Technology)公司,为企业公关广告,市场
            营销和运营提供基于社交媒体大数据的传播决策服务，识别战场状况，提高心智占有率，计算品牌在数字时代的数字资产价值。 数字品牌榜，社交媒体时代的用户口碑评价排行榜。</span>

        </div>

      </div>

    // return (   <div className={s.root}>     <div className={s.container}>
    // <a         className={s.link}
    // href="https://gitter.im/kriasoft/react-starter-kit"       >Ask a question</a>
    //       <span className={s.spacer}>|</span>       <a         className={s.link}
    //         href="https://github.com/kriasoft/react-starter-kit/issues/new"
    // >Report an issue</a>     </div>   </div> );
    );
  }
}

export default withStyles(s)(Feedback);



// WEBPACK FOOTER //
// src/components/Dbranks/Feedback.js